import React from "react";

const CheckField = (prefectures) => {
  const handleCheck = {};

  return (
    <div>
      {/* {prefectures.map((prefecture) => (
        <div key={prefecture.prefName}>
          <input type="checkbox" name="Prefecture name" />
          {prefecture.prefName}
        </div>
      ))} */}
    </div>
  );
};

export default CheckField;
